// Finans tekil detay PDF'leri (Ödenek + Hakediş) — detay kartıyla aynı bölümler
import { startReport, addHeading, addTable, addKpis, addParagraph, finishReport, stamp } from './reportPdf';
import { talepYeriLabel, odenekTuruLabel, durumLabel, ihaleOnayiLabel, fmtTarih, ekSatirlar, toplamOdenek, toplamHakedis, toTLString, parseTL, yuzde } from '../components/modules/odenek/finansOrtak';

const GRAY = [107, 114, 128];
const kv = (pairs) => {
  const rows = [];
  for (let i = 0; i < pairs.length; i += 2) rows.push([pairs[i][0], pairs[i][1] || '-', pairs[i + 1]?.[0] || '', pairs[i + 1] ? (pairs[i + 1][1] || '-') : '']);
  return rows;
};
const section = (ctx, title, pairs) => {
  addHeading(ctx, title, 1);
  addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], kv(pairs), { fontSize: 8, columnStyles: { 0: { textColor: GRAY, cellWidth: 40 }, 2: { textColor: GRAY, cellWidth: 40 } } });
};
const safeName = (s) => String(s || '').replace(/[^0-9A-Za-zÇĞİÖŞÜçğıöşü_-]+/g, '-').slice(0, 40);
const hakedisTablosu = (ctx, liste, displayMoney, vurguId) => addTable(ctx, ['#', 'Hakediş No', 'Talep Yeri', 'Talep Tarihi', 'Tutar', 'Ödeme Durumu'],
  liste.map((x, i) => [String(i + 1), `${x.hakedis_no || '-'}${x.id === vurguId ? ' (bu kayıt)' : ''}`, talepYeriLabel(x.talep_yeri), fmtTarih(x.talep_tarihi) || '-', displayMoney(x.talep_tutari) || '-', durumLabel(x.odeme_durumu)]),
  { fontSize: 8, columnStyles: { 0: { cellWidth: 8 }, 4: { halign: 'right', cellWidth: 36 } } });

export function exportFinansOdenekDetayPDF(od, { displayMoney, hakedisler = [] }) {
  const money = (n) => displayMoney(toTLString(n)) || '-';
  const bagli = hakedisler.filter(h => h.odenek_id === od.id);
  const toplam = toplamOdenek(od);
  const hakToplam = toplamHakedis(bagli);
  const kalan = toplam - hakToplam;
  const ctx = startReport({ title: `Ödenek Detay Raporu — ${od.yil} ${odenekTuruLabel(od.odenek_turu)}`, subtitle: od.isin_adi || '', orientation: 'portrait', meta: 'Finans › Ödenek' });
  addKpis(ctx, [
    { label: 'Talep Tutarı (KDV Hariç)', value: displayMoney(od.talep_tutari) || '-' },
    { label: 'Toplam Ödenek (ek dahil, iptal hariç)', value: money(toplam) },
    { label: 'Toplam Hakediş', value: bagli.length ? money(hakToplam) : '-', sub: `${bagli.length} hakediş` },
    { label: 'Kalan Ödenek', value: toplam > 0 ? `${kalan < 0 ? '-' : ''}${money(Math.abs(kalan))}` : '-' },
  ]);
  section(ctx, '1. Temel Bilgiler', [
    ['Yıl', String(od.yil || '')], ['Talep Yeri', talepYeriLabel(od.talep_yeri)], ['Ödenek Türü', odenekTuruLabel(od.odenek_turu)], ['Alım Türü', od.alim_turu], ['İşin Adı', od.isin_adi],
  ]);
  section(ctx, '2. Talep ve Durum', [
    ['Talep Tarihi', fmtTarih(od.talep_tarihi)], ['Talep Yazısı Sayı/No', od.talep_yazisi_sayi_no],
    ['Talep Tutarı (KDV Hariç)', displayMoney(od.talep_tutari)], ['Ödenek Durumu', durumLabel(od.odenek_durumu)],
  ]);
  section(ctx, '3. İhale Onayı', [
    ['İhale Onayı', ihaleOnayiLabel(od.ihale_onayi)], ['Talep Tarihi', fmtTarih(od.ihale_onayi_talep_tarihi)], ['Talep Yazısı', od.ihale_onayi_talep_yazisi],
  ]);
  addHeading(ctx, '4. Ek Taahhütler ve Ek Protokoller', 1);
  const ekler = [...ekSatirlar(od, 'taahhut').map(x => ({ ...x, tip: 'Ek Taahhüt' })), ...ekSatirlar(od, 'protokol').map(x => ({ ...x, tip: 'Ek Protokol' }))];
  if (ekler.length) {
    addTable(ctx, ['Tür', 'Talep Yeri', 'Tarih', 'Yazı', 'Tutar', 'Durum'], ekler.map(x => [x.tip, talepYeriLabel(x.talep_yeri), fmtTarih(x.tarih) || '-', x.yazisi || '-', displayMoney(x.tutari || '') || '-', durumLabel(x.durumu)]),
      { fontSize: 8, columnStyles: { 4: { halign: 'right', cellWidth: 36 } } });
  } else {
    addParagraph(ctx, 'Ek taahhüt / ek protokol kaydı yok.', { color: GRAY });
  }
  addHeading(ctx, '5. Bağlı Hakedişler', 1);
  if (bagli.length) hakedisTablosu(ctx, bagli, displayMoney); else addParagraph(ctx, 'Bu ödeneğe bağlı hakediş yok.', { color: GRAY });
  finishReport(ctx, `odenek-detay-${safeName(od.yil)}-${safeName(od.isin_adi)}-${stamp()}.pdf`);
}

export function exportHakedisDetayPDF(h, { displayMoney, odenek, hakedisler = [] }) {
  const money = (n) => displayMoney(toTLString(n)) || '-';
  const liste = hakedisler.filter(x => x.odenek_id === h.odenek_id);
  const sira = liste.findIndex(x => x.id === h.id) + 1;
  const toplamOd = odenek ? toplamOdenek(odenek) : 0;
  const hakToplam = toplamHakedis(liste);
  const kalan = toplamOd - hakToplam;
  const ctx = startReport({ title: `Hakediş Detay Raporu — ${h.hakedis_no || ''}`, subtitle: h.odenek_isin_adi || odenek?.isin_adi || '', orientation: 'portrait', meta: 'Finans › Hakediş' });
  addKpis(ctx, [
    { label: 'Talep Tutarı', value: displayMoney(h.talep_tutari) || '-' },
    { label: 'Ödeme Durumu', value: durumLabel(h.odeme_durumu) || '-' },
    { label: 'Toplam Hakediş', value: money(hakToplam), sub: sira ? `${sira}. / ${liste.length} hakediş` : '' },
    { label: 'Kalan Ödenek', value: toplamOd > 0 ? `${kalan < 0 ? '-' : ''}${money(Math.abs(kalan))}` : '-' },
  ]);
  section(ctx, '1. Hakediş Bilgileri', [
    ['Hakediş No', h.hakedis_no], ['Yıl', String(h.yil || '')], ['Talep Yeri', talepYeriLabel(h.talep_yeri)], ['Talep Tarihi', fmtTarih(h.talep_tarihi)], ['Talep Yazısı Sayı/No', h.talep_yazisi_sayi_no],
  ]);
  section(ctx, '2. Tutar ve Ödeme Durumu', [['Talep Tutarı', displayMoney(h.talep_tutari)], ['Ödeme Durumu', durumLabel(h.odeme_durumu)]]);
  if (odenek) {
    section(ctx, '3. Bağlı Ödenek', [
      ['İşin Adı', odenek.isin_adi], ['Yıl', String(odenek.yil || '')], ['Ödenek Türü', odenekTuruLabel(odenek.odenek_turu)], ['Talep Yeri', talepYeriLabel(odenek.talep_yeri)],
      ['Ödenek Talep Tutarı', displayMoney(odenek.talep_tutari)], ['Toplam Ödenek (ek dahil, iptal hariç)', money(toplamOd)], ['Ödenek Durumu', durumLabel(odenek.odenek_durumu)],
    ]);
  } else {
    addHeading(ctx, '3. Bağlı Ödenek', 1); addParagraph(ctx, `Bağlı ödenek kaydı bulunamadı. İş: ${h.odenek_isin_adi || '-'}`, { color: GRAY });
  }
  section(ctx, '4. İşin Hakediş Özeti', [
    ['Hakediş Sayısı', String(liste.length)], ['Toplam Hakediş', money(hakToplam)],
    ['Bu Hakedişin Payı', yuzde(parseTL(h.talep_tutari), toplamOd || hakToplam)], ['Kalan Ödenek', toplamOd > 0 ? `${kalan < 0 ? '-' : ''}${money(Math.abs(kalan))}` : '-'],
  ]);
  if (liste.length > 1) hakedisTablosu(ctx, liste, displayMoney, h.id);
  finishReport(ctx, `hakedis-detay-${safeName(h.hakedis_no || h.yil)}-${stamp()}.pdf`);
}
